(function () {
  'use strict';

  angular
    .module('unit.type.change')
    .directive('unitTypeChange', unitTypeChange);

  unitTypeChange.$inject = [];

  function unitTypeChange() {
    var directive = {
      bindToController: true,
      controller: 'unitTypeChangeCtrl',
      controllerAs: 'vm',
      template: require('../unit.type.change/unit.type.change.html'),
      link: link,
      restrict: 'EA',
      scope: {
        sectionId: '@',
      },
    };
    return directive;

    function link(scope, element, attrs, ctrl) {}
  }
})();
